
import Hero from './hero';
import Benefits from './benefits';
import HowItWorks from './how-it-works';
import ConversationPaths from './conversation-paths';
import FAQ from './faq';
import FinalCTA from './final-cta';
import FloatingClouds from './floating-clouds';
import Footer from '../../Footer';
import Header from '../../Header';

export default function BoggleGuideSignupPage({
  onApply,
  showFooter = true,
  logoSrc = '/boggler-logo.webp',
}) {
  return (
    <>
      <Header logoSrc={logoSrc} />
      <main className="relative overflow-hidden">
        <FloatingClouds />
        <Hero logoSrc={logoSrc} onApply={onApply} />
        <Benefits />
        <HowItWorks />
        <ConversationPaths onApply={onApply} />
        {/* <Testimonials /> */}
        <FAQ />
        <FinalCTA onApply={onApply} />

        {showFooter && (
          <Footer logoSrc={logoSrc} />
        )}
      </main>
    </>
  );
}
